import $ from 'jquery'
import { attachDynamicEvent } from '~/common/helpers/dom'
import ActiveStorageDirectUploader from './active_storage_direct_uploader'

// tries to replicate app/javascript/controllers/file_controller.js

// Prefer the list inside this uploader wrapper. Falling back to the first
// [data-file-target=filesList] on the page (or even the first in the form)
// is what grouped worksheet file previews onto the first question.
const filesListFor = (element) => {
  const inWrapper = $(element)
    .closest('.active_storage_files_wrapper')
    .find('[data-file-target=filesList]')
  if (inWrapper.length) return inWrapper

  const inForm = $(element).closest('form').find('[data-file-target=filesList]')
  if (inForm.length) return inForm

  return $('[data-file-target=filesList]')
}

const listFiles = (filesUploader, filesListTarget) => {
  const files = filesUploader.files
  filesListTarget.empty()
  if (files.length > 0) {
    const title = document.createElement('p')
    title.textContent = 'Selected files:'
    filesListTarget.append(title)
  }
  let file
  for (let i = 0; i < files.length; i++) {
    file = document.createElement('li')
    file.classList.add('listed_file')
    file.textContent = files[i].name
    filesListTarget.append(file)
  }
}

// clear files list after clicking file-upload-btn
attachDynamicEvent('.file-upload-btn', 'click', (e) => {
  const filesListTarget = filesListFor(e.target)

  if (filesListTarget.length) {
    e.target.value = ''
    filesListTarget.empty()
  }
})

attachDynamicEvent('.active_storage_file_uploader_input', 'change', (e) => {
  const filesListTarget = filesListFor(e.target)

  // handle direct upload
  if (
    e.target.hasAttribute('data-direct-upload-url') &&
    filesListTarget.length > 0
  ) {
    const uploader = new ActiveStorageDirectUploader(
      e.target,
      filesListTarget[0]
    )
    uploader.handleFilesUpload()
  } else if (
    // list file if there is a div to render chosen files, and we're not doing a direct-upload
    filesListTarget &&
    !e.target.hasAttribute('data-direct-upload-url')
  ) {
    listFiles(e.target, filesListTarget)
  }
})
